import { Box, Button } from 'braid-design-system';
import queryString from 'query-string';

import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import { useAuth } from 'src/hooks/auth';
import { AnalyticsEvent, fireRegistrationEvent } from 'src/utils/analytics';

import * as styles from './GetStartedButton.css';

interface GetStartedButtonProps {
  colour: 'white' | 'blue';
}

export const GetStartedButton = ({ colour }: GetStartedButtonProps) => {
  const isLogin = useAuth();

  const onRegisterClick = async () => {
    // If user is logged in or has logged in before
    const isLoggedIn = isLogin.getAuthToken();
    if (!isLoggedIn) {
      await fireRegistrationEvent(AnalyticsEvent.RegistrationStartSem);
      const anHourLater = new Date();
      anHourLater.setHours(anHourLater.getHours() + 1);
      // Code kept as a comment to show prior implementation
      // setGlobalCookie('OnboardPageSource', 'SEMLandingPage', '/');
    }

    window.location.assign(
      `${queryString.stringifyUrl({
        url: getConfigValues().HEADER_SERVER_BASE + Routes.SIGN_IN_URL,
        query: {
          returnPath: Routes.DASHBOARD,
        },
      })}`,
    );
  };

  return (
    <Box
      className={{ [styles.buttonWhite]: colour === 'white' }}
      maxWidth="large"
    >
      <Button tone="brandAccent" onClick={onRegisterClick}>
        Get Started
      </Button>
    </Box>
  );
};
